export default __webpack_public_path__ + "static/Office_image_5-ae4f22b24eb229c6dd4e60e89d679bb6.png";